/**
 * Residual lazy-loaded components used by reference layout files
 * (BlogLayout, BrowseLayout, DocsLayout).
 *
 * Dashboard and auth components have been moved to routeConfig.jsx.
 */
import { lazy, Suspense } from 'react'
import LoadingScreen from '@/components/LoadingScreen'

const Loadable = (Component) => (props) => (
    <Suspense fallback={<LoadingScreen />}>
        <Component {...props} />
    </Suspense>
)

// Browse pages
export const Browse = Loadable(lazy(() => import('@/pages/browse/Browse')))
export const BrowseButtons = Loadable(
    lazy(() => import('@/pages/browse/BrowseButtons'))
)
export const BrowseCharts = Loadable(
    lazy(() => import('@/pages/browse/BrowseCharts'))
)
export const BrowseColors = Loadable(
    lazy(() => import('@/pages/browse/BrowseColors'))
)
export const BrowseDetailLists = Loadable(
    lazy(() => import('@/pages/browse/BrowseDetailLists'))
)
export const BrowseForms = Loadable(
    lazy(() => import('@/pages/browse/BrowseForms'))
)
export const BrowseGridLists = Loadable(
    lazy(() => import('@/pages/browse/BrowseGridLists'))
)
export const BrowseGroupedLists = Loadable(
    lazy(() => import('@/pages/browse/BrowseGroupedLists'))
)
export const BrowseInputs = Loadable(
    lazy(() => import('@/pages/browse/BrowseInputs'))
)
export const BrowseModals = Loadable(
    lazy(() => import('@/pages/browse/BrowseModals'))
)
export const BrowseQuickStats = Loadable(
    lazy(() => import('@/pages/browse/BrowseQuickStats'))
)
export const BrowseTables = Loadable(
    lazy(() => import('@/pages/browse/BrowseTables'))
)
export const BrowseTypography = Loadable(
    lazy(() => import('@/pages/browse/BrowseTypography'))
)

// Blog pages
export const BlogPostCreate = Loadable(
    lazy(() => import('@/pages/blog/BlogPostCreate'))
)
export const BlogPostDetails = Loadable(
    lazy(() => import('@/pages/blog/BlogPostDetails'))
)
export const BlogPostList = Loadable(
    lazy(() => import('@/pages/blog/BlogPostList'))
)

// Docs pages
export const Docs = Loadable(lazy(() => import('@/pages/Docs')))
